import React from 'react';
import cn from 'classnames';

import { useSiteMetaData } from '../util/queries/site';

import { externalLink } from '../util';

import Wrapper from './Wrapper';
import BtgLogo from './logos/btg';
import UaiLogo from './logos/Uai';

import LinkedinIcon from './icons/Linkedin';
import TwitterIcon from './icons/Twitter';
import SpotifyIcon from './icons/Spotify';
import InstagramIcon from './icons/Instagram';
import YoutubeIcon from './icons/Youtube';

import * as styles from './Footer.module.css';

const Footer = () => {
  const { socialMedia } = useSiteMetaData();

  const socialMediaLinks = [
    {
      name: 'LinkedIn',
      icon: <LinkedinIcon />,
      url: socialMedia.linkedin
    },
    {
      name: 'Twitter',
      icon: <TwitterIcon />,
      url: socialMedia.twitter
    },
    {
      name: 'Spotify',
      icon: <SpotifyIcon />,
      url: socialMedia.spotify
    },
    {
      name: 'Instagram',
      icon: <InstagramIcon />,
      url: socialMedia.instagram
    },
    {
      name: 'Youtube',
      icon: <YoutubeIcon />,
      url: socialMedia.youtube
    }
  ];

  return (
    <footer className={cn(styles.root)}>
      <Wrapper className={cn(styles.wrapper)}>
        <div className={styles.logos}>
          <a
            className={styles.btgLogo}
            href="https://btgpactual.cl/"
            {...externalLink}
          >
            <BtgLogo className={styles.btgLogo} />
          </a>
          <div className={styles.uai}>
            <p>Colabora:</p>
            <a
              className={styles.uaiLogo}
              href="https://artesliberales.uai.cl/"
              {...externalLink}
            >
              <UaiLogo className={styles.btgLogo} />
            </a>
          </div>
        </div>
        <nav className={cn(styles.socialLinks)}>
          {socialMediaLinks.map(({ name, icon, url }) => (
            <a key={name} href={url} {...externalLink}>
              <span className={cn(styles.socialIcon)}>{icon}</span>{' '}
              <span>{name}</span>
            </a>
          ))}
        </nav>
      </Wrapper>
    </footer>
  );
};

export default Footer;
